import { Button } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { Card, Header2, Header3, Header4 } from "@dash/page";
import { useTheme } from "@emotion/react";
import React from "react";
import { MdCheck, MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

type Props = {
  onCommit: () => Promise<void>;
  onExit?: () => void;
  className?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export const SyncBar: React.FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { mq } = useDeviceType();

  const onExit = props.onExit ?? (() => navigate(-1));

  const onConfirm = async () => {
    await props.onCommit();
    onExit();
  };

  return (
    <Card
      className={props.className}
      css={{
        display: "flex",
        gap: "0.5rem",
        width: "100%",
        padding: "0.5rem 1rem",
        position: "sticky",
        [mq("tablet")]: {
          flexDirection: "row",
          alignItems: "center",
        },
      }}
    >
      <span css={{ color: theme.colors.background, margin: 0 }}>Synchronizacja danych</span>
      <div css={{ flexGrow: "1" }}></div>
      <Button color="inverse" variant="outline" icon={<MdClose />} onClick={onExit}>
        Anuluj
      </Button>

      <Button
        isLoading={props.isLoading}
        color="inverse"
        icon={<MdCheck />}
        onClick={onConfirm}
        isDisabled={props.isDisabled}
      >
        Zatwierdź
      </Button>
    </Card>
  );
};
